import { apiRequest } from "../../index";
import config from "../../../../config";

const { VCHAT_API } = config;
const api = `${VCHAT_API}/invites`;

export async function getUserInvites({ username, classroomId }) {
  try {
    const response = await apiRequest(
      `${api}/${username}/classroom/${classroomId}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}

// userId and meetingid needed in body
export async function createInvite(body) {
  try {
    const response = await apiRequest(`${api}/`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteInvite({ userId, meetingId }) {
  try {
    const response = await apiRequest(
      `${api}/${userId}/${meetingId}`,
      "DELETE",
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateInvite({ creator, meetingId, values }) {
  const response = await apiRequest(
    `${api}/${creator}/${meetingId}`,
    "PATCH",
    values,
  );
  return response;
}
